import { useEffect, useState, memo } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import { Formik, useFormik, FormikProvider, Field } from 'formik';
import {DebounceInput} from 'react-debounce-input';
import InputAdornment from '@mui/material/InputAdornment';


const FragmentRowVol = memo((props) => {
    const data = props.data;
    const updateFragment = props.updateFragment;
    const submitShowError = props.submitShowError;
    const errorVol = props.errorVol;

    return (
        <Grid item>
            <Grid item alignItems="stretch"
                  style={{display: 'flex', width: 65}}>
                <DebounceInput
                    debounceTimeout={500}
                    minLength={1}
                    element={TextField}
                    id="vol"
                    placeholder={"Vol"}
                    variant="outlined"
                    value={data.vol}
                    multiline
                    sx={{
                        width: 300,
                        '& .MuiInputBase-root': {
                            minHeight: 40,
                            borderRadius: 0,
                            width: 65
                        },
                        '& legend': {display: 'none'},
                        '& fieldset': {top: 0},
                        "& .MuiInputBase-input": {
                            marginTop: -2,
                            marginBottom: -2
                        }
                    }}
                    InputProps={{
                        inputmode: 'numeric',
                        pattern: '[0-9]*',
                        endAdornment: <InputAdornment
                            style={{size: 10, marginLeft: -2, marginRight: -10}}
                            position="end">µl</InputAdornment>
                    }}
                    onBlur={(e) => {
                        var newTouched = [...data.touched];
                        newTouched[1] = true;
                        updateFragment({touched: newTouched}, props.id);
                    }}
                    onChange={async (e) => {
                        // var valInput = e.target.value !== undefined ? e.target.value : "0";
                        // var val = strReturnOnlyNumbersPositive(valInput);
                        var newTouched = [...data.touched];
                        newTouched[1] = true;
                        updateFragment({
                            vol: e.target.value,
                            touched: newTouched
                        }, props.id);
                    }}
                    error={((submitShowError)) && errorVol(data.vol)}
                />
            </Grid>
        </Grid>
    );
},
    (prevProps, nextProps) => {
        return prevProps.id === nextProps.id && prevProps.data.vol === nextProps.data.vol;
    });



export default FragmentRowVol;